import React from 'react';

export const keyFeatures = [
  {
    id: 'earn-ios-and-smart-wallet',
    item: (
      <span className="font-normal">
        <span className="font-semibold">EarnOS and SmartWallet:&nbsp;</span>
        Converts user engagement into on-chain rewards by subsidizing transaction fees across any
        EVM-compatible chain.
      </span>
    ),
  },
  {
    id: 'fractal-assets',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Fractal Assets:&nbsp;</span>
        Rewards in Mystery Boxes and DropBoxes bridge Web2 and Web3 user experiences.
      </span>
    ),
  },
  {
    id: 'depin-technology',
    item: (
      <span className="font-normal">
        <span className="font-semibold">DePIN Technology:&nbsp;</span>
        Distributed physical internet (DePIN) structure through a broad retail and digital network
        enhances distribution and user engagement.
      </span>
    ),
  },
  {
    id: 'industry-leading-partners',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Industry-Leading Partners:&nbsp;</span>
        Strategic partnerships with key platforms, including Binance, Coinbase, and a retail network
        that spans Walmart to Amazon.
      </span>
    ),
  },
];

export const tokenUtility = [
  {
    id: 'fractal-box-protocol',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Fractal Box Protocol:&nbsp;</span>
        Underpins Mystery Boxes, DropBoxes, and OTC Boxes, with each asset facilitating unique user
        engagements.
      </span>
    ),
  },
  {
    id: 'earnings-back',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Earnings Back to the Ecosystem:&nbsp;</span>
        Revenue from user transactions and partner arrangements are reinvested.
      </span>
    ),
  },
  {
    id: 'scaling',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Layer 2 Scaling:&nbsp;</span> As the ecosystem scales,
        $EARNM will optimize integration for Web2 and Web3 projects, supporting Earn’M’s growth and
        innovation.
      </span>
    ),
  },
];

export const marketTraction = [
  {
    id: 'key-metrics',
    content: 'Key Metrics:',
    item: [
      {
        id: 'wallets',
        subItem: <span className="font-normal">75,000+ unique daily active wallets.</span>,
      },
      {
        id: 'assets',
        subItem: (
          <span className="font-normal">
            20M+ assets minted and 5% of all Polygon transaction volume.
          </span>
        ),
      },
      {
        id: 'revenue',
        subItem: (
          <span className="font-normal">
            $65M+ in Web2 revenue with over 45 million Web2 users onboarded.
          </span>
        ),
      },
      {
        id: 'users',
        subItem: (
          <span className="font-normal">
            Extensive Web3 user base of 10M+ and 18.6B+ user minutes recorded.
          </span>
        ),
      },
      {
        id: 'reviews',
        subItem: <span className="font-normal">2.3M+ 5-star Google Play reviews.</span>,
      },
    ],
  },
  {
    id: 'revenue-milestones',
    content: 'Revenue Milestones:',
    item: [
      {
        id: 'saved',
        subItem: (
          <span className="font-normal">
            $350M earned/saved by users and $3M+ in network fees collected.
          </span>
        ),
      },
    ],
  },
  {
    id: 'growth',
    content: 'Growth Recognition:',
    item: [
      {
        id: 'deloitte',
        subItem: (
          <p className="font-normal mb-6">
            Deloitte ranked Earn’M as North America’s fastest-growing company in 2023, boasting a
            growth rate of 32,481%.
          </p>
        ),
      },
    ],
  },
];

export const teamMembers = [
  {
    id: 'dan-novaes',
    fullName: 'Dan Novaes',
    width: 104,
    height: 104,
    position: 'CEO, Co-Founder',
    avatar: '/launchpad/stories/earnM/dan-novaes.png',
  },
  {
    id: 'kiran-panesar',
    fullName: 'Kiran Panesar',
    width: 104,
    height: 104,
    position: 'CPO',
    avatar: '/launchpad/stories/earnM/kiran-panesar.png',
  },
];
